import { BrowserRouter } from "react-router-dom";

import AppProviders from "./AppProviders";
import AppRoutes from "./AppRoutes";
import DeferredThirdPartyScripts from "./components/DeferredThirdPartyScripts";
import ScrollToTop from "./components/ScrollToTop";

const App = () => (
  <AppProviders>
    <BrowserRouter>
      <ScrollToTop />
      <DeferredThirdPartyScripts />
      <AppRoutes />
    </BrowserRouter>
  </AppProviders>
);

export default App;
